import $ from 'jquery';
import 'owl.carousel';

jQuery(function ($) { 
	var current = 1; 
	var steps = 5; 

	setProgressBar(current); 

	$(".next-step").on( 'click', function (e)
	{ 
        // check class exists
        if( !e.target.classList.contains('next-step') )
            return;

		let curProgress = $("#progressbar li.active");
		curProgress.next().addClass("active"); 
		setProgressBar(++current); 
	}); 

	$(".previous-step").on('click', function ()
	{ 
		let curProgress = $("#progressbar li.active");
		curProgress.last().removeClass("active");
		
		setProgressBar(--current); 
	}); 

	function setProgressBar(currentStep) { 
		var percent = parseFloat(100 / steps) * current; 
		percent = percent.toFixed(); 
		$(".progress-bar").css("width", percent + "%") 
	} 

	//from process old code

	//shared cabin quantity
	$('.shared .quantity').on('click', '.switcher', function()
	{
		let warningMsg = $('.shared-cabin-msg');
		if( warningMsg.length > 0 )
		{
			warningMsg.fadeOut(1000, function(){
				warningMsg.remove();
			});
		}

		let math = $(this).attr('math');
		let qtyEle = $(this).parent().find('.count');
		let qty = parseInt(qtyEle.text());
		
		if( math == '+' )
		{
			if( qty == $(this).attr('max') ) 
			{
				//create warning message element after .shared .option
				let warning = $('<p class="small text-danger text-center shared-cabin-msg">Maximum cabin quantity reached</p>');
				$(this).parent().parent().after( warning );
				return false;
			}
			qty++;
			qtyEle.text( qty );
		}
		else if( math == '-' )
		{
			if( qty == $(this).attr('min') )
			{
				let warning = $('<p class="small text-danger text-center shared-cabin-msg">Minimum cabin quantity reached</p>');
				$(this).parent().parent().after( warning );
				return false;
			}
			qty--
			qtyEle.text( qty );
		}
		$('fieldset[sfview="dgp34s"]').find('.shared .cabinsqty').text( qty );
		$('fieldset[sfview="dgp34s"]').find('.shared .cabinpersons').text( qty * 2 );
		calcTotal( qty );

	});

	//cruise gallery owl carousel
	$('.owl-carousel').owlCarousel({
		items:1,
		loop:false,
		autoHeight: false,
		margin:10
	});

}); 
